import MsgList from './MsgList'
import PageLayout from '../../components/layouts/PageLayout'
import CustomNavbar from '../../components/common/CustomNavbar'

export default function Reports() {
  return (
    <PageLayout
      customNavbar={
        <CustomNavbar>
          <div className="flex gap-3 items-center w-max">
            <span className="font-bold text-lg uppercase">
              MESSAGE REPORTS
            </span>
          </div>
        </CustomNavbar>
      }
    >      <MsgList />
    </PageLayout>
  )
}
